export default __webpack_public_path__ + "static/java-header-cc54d1a5a8353223b01adc1d5044bf52.jpg";